import { supabase } from '../lib/supabaseClient';

export const DEV_API_BASE_URL = (
  process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000'
).replace(/\/+$/, '');

function extractErrorMessage(payload, status) {
  const value = (
    payload?.detail?.error?.message ||
    payload?.detail?.message ||
    payload?.detail ||
    payload?.error?.message ||
    payload?.message
  );
  if (typeof value === 'string') return value;
  if (value) return JSON.stringify(value);
  return `HTTP ${status}`;
}

async function parseResponse(response, responseType) {
  if (!response.ok) {
    const payload = await response.json().catch(() => null);
    const error = new Error(extractErrorMessage(payload, response.status));
    error.status = response.status;
    throw error;
  }
  if (response.status === 204) return null;
  if (responseType === 'blob') return response.blob();
  return response.json();
}

async function sessionToken({ refresh = false } = {}) {
  const result = refresh
    ? await supabase.auth.refreshSession()
    : await supabase.auth.getSession();
  if (result.error) throw result.error;
  const token = result.data?.session?.access_token;
  if (!token) throw new Error('Your Latted session has expired. Sign in again.');
  return token;
}

export async function devApi(path, options = {}, retry = true) {
  const token = await sessionToken();
  const isFormData = options.body instanceof FormData;
  const response = await fetch(`${DEV_API_BASE_URL}${path}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...(options.headers || {}),
    },
  });

  if (response.status === 401 && retry) {
    await sessionToken({ refresh: true });
    return devApi(path, options, false);
  }

  return parseResponse(response, options.responseType);
}

export function isFrontendDevToolsEnabled(env = process.env) {
  return env.REACT_APP_ENVIRONMENT === 'development';
}

export function parseDecompositionBatch(value) {
  return value
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const parts = line.split(/\s+\|\s+/);
      const video_url = parts.shift().trim();
      const overlay_hints = parts.join(' | ').split(';').map((hint) => hint.trim()).filter(Boolean);
      return { video_url, overlay_hints };
    });
}
